import { Collection } from 'modules/core/lib/mobx-rest'

import LegalEntitySettings from 'modules/payroll_exporter/store/models/LegalEntitySettings'

class LegalEntitiesSettings extends Collection<LegalEntitySettings> {
  get cacheKey(): string {
    return 'legalEntitiesSettings'
  }

  override model() {
    return LegalEntitySettings
  }

  findLegalEntity(legalEntityId: number) {
    return this.find((legalEntity) => legalEntityId === legalEntity.attributes.id)
  }
}

const singleton = new LegalEntitiesSettings()

export default singleton
